﻿import React from "react";
import { injectFromAppLegal } from "../inject";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { PrivacyPolicyCountry } from "./PrivacyPolicyCountry";

interface IPrivacyPolicyDocumentComponentProps {
    country: PrivacyPolicyCountry;
    resourcesStore?: IResourcesStore;
}

@injectFromAppLegal<IPrivacyPolicyDocumentComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
export class PrivacyPolicyDocumentComponent extends React.Component<IPrivacyPolicyDocumentComponentProps> {
    render() {
        const { country, resourcesStore } = this.props;
        const { resources } = resourcesStore!;

        return (
            <object data={`/POW4/resources/privacy-policy/${country}`} type="application/pdf" width="100%" height="800px">
                <p>
                    {resources.BrowserDoesNotSupportPdf} <a href={`/POW4/resources/privacy-policy/${country}`}>{resources.DownloadThePDF}</a>.
                </p>
            </object>
        );
    }
}
